// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Sg-z","heading":"Tg-z"};